// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__lK8ML","list":"styles_list__2ehor"};